import { ActionType, createAsyncAction } from 'typesafe-actions'
import { Failure, Request, Success } from './types'
import { ChatState } from '../../types'

export const addParticipantToGroupAction = createAsyncAction(
  '@chat/ADD_PARTICIPANT_TO_GROUP_REQUEST',
  '@chat/ADD_PARTICIPANT_TO_GROUP_SUCCESS',
  '@chat/ADD_PARTICIPANT_TO_GROUP_FAILURE'
)<Request, Success, Failure>()

const request = (state: ChatState): ChatState => ({
  ...state,
  isLoadingAddParticipantToGroup: true
})

const success = (state: ChatState, action: ActionType<typeof addParticipantToGroupAction.success>): ChatState => {
  const { updatedChatData } = action.payload
  return {
    ...state,
    activeChat: { ...state.activeChat, ...updatedChatData },
    isSuccessOnAddParticipantToGroup: true,
    isLoadingAddParticipantToGroup: false
  }
}
const failure = (state: ChatState): ChatState => ({
  ...state,
  isLoadingAddParticipantToGroup: false,
  isErrorOnAddParticipantToGroup: true
})

export const addParticipantToGroupHandle = { asyncAction: addParticipantToGroupAction, request, success, failure }
